
import * as React from 'react';
import { observer } from 'mobx-react-lite';
import styled from '@emotion/styled';

interface PropsType {
    className?: string
}

const SvgWrapper = styled('svg', { label: 'SvgWrapper' })<PropsType>`
    height: auto;
`;

export const PlusIcon = observer(( {className}: PropsType ): React.ReactElement => (
    <SvgWrapper width={16} height={16} className={className} fill='#fff' viewBox='0 0 16 16'>
        <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M7 7.5V4.5C7 3.94772 7.44772 3.5 8 3.5C8.55228 3.5 9 3.94772 9 4.5V7.5H12C12.5523 7.5 13 7.94772 13 8.5C13 9.05228 12.5523 9.5 12 9.5H9V12.5C9 13.0523 8.55228 13.5 8 13.5C7.44772 13.5 7 13.0523 7 12.5V9.5H4C3.44772 9.5 3 9.05228 3 8.5C3 7.94772 3.44772 7.5 4 7.5H7Z'
            fill='#fill'
        />
    </SvgWrapper>
));



